import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import cn from 'classnames';
import { FormLabel } from '@sbt-web/ui';
import { NewBadge } from '../NewBadge';
import type { CommonFilterProps } from './types';
import commonClasses from './styles.module.scss';
type Props = CommonFilterProps & {
  children: string;
  extraContent?: ReactNode;
  className?: string;
};
export const FilterLabel = t0 => {
  const $ = _c(11);
  const {
    children,
    extraContent,
    showBadgeNew,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn(commonClasses["filter-label"], className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <FormLabel>{children}</FormLabel>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== showBadgeNew) {
    t3 = showBadgeNew && <NewBadge />;
    $[4] = showBadgeNew;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== extraContent || $[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
    t4 = <div className={t1}>{t2}{t3}{extraContent}</div>;
    $[6] = extraContent;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};